import React from "react";
import "./PositionsSpain.css";
import useSPPosition from "../../hooks/useSPPosition";
import { ignoreEnter, handleFigureChange, handleFigureBlur } from "./utils/inputhandlers";
import useSPUndo from "../../hooks/useSPUndo";

const SPPositionFormGroup = ({ labelname, inputname, inputtype, style, readOnly, type, rowStyle, cplaceholder }) => {
  // Load context data
  const { SPposition, setSPposition, setSPpositionData } = useSPPosition();
  const { positionEditsSP, editIDSP, setEditIDSP, editingFieldSP, setEditingFieldSP, undoListSP, inputRefsSP } =
    useSPUndo();

  return (
    <div className='form-group' style={rowStyle}>
      <label>{labelname}:</label>
      {readOnly ? (
        <input
          readOnly
          disabled
          type={type || "text"}
          style={{ border: "none" }}
          autoComplete='off'
          onKeyDown={ignoreEnter}
          onFocus={(e) => e.target.select()}
          value={SPposition?.[inputname] || ""}
          name={inputname}
          tabIndex={-1}
        />
      ) : (
        <input
          required
          type={type || "text"}
          name={inputname}
          value={SPposition?.[inputname] ? SPposition?.[inputname] : SPposition?.[inputname] === 0 ? 0 : ""}
          autoComplete='off'
          onKeyDown={ignoreEnter}
          onFocus={(e) => e.target.select()}
          onChange={(e) => handleFigureChange(e, inputtype, setSPposition, setSPpositionData, setEditingFieldSP)}
          onBlur={(e) =>
            handleFigureBlur(
              e,
              inputtype,
              setSPposition,
              positionEditsSP,
              editIDSP,
              setEditIDSP,
              editingFieldSP,
              setEditingFieldSP,
              undoListSP
            )
          }
          style={style}
          placeholder={cplaceholder}
          ref={(el) => (inputRefsSP.current[inputname] = el)}
        />
      )}
    </div>
  );
};

export default SPPositionFormGroup;
